:host {
    --outline-opacity: 0.7;
    --inline-padding: 0;
    display: block;

    /**
    * @prop --primary-color: The color of the accordion title. Default value --color-highlight
    * @prop --outline-opacity: The opacity of the outline when it's focused. Default value 0.7
    * @prop --inline-padding: The padding of the content. Default value 0
    */
}

:host([innerpadding])  {
    --inline-padding: 2rem;
}

:host([accordion]) details  {
    --accordion-margin:1rem;
}

:host([large]) details {
    --accordion-title-size:clamp(1.5rem, 3vmin, 2.5rem);
}

:host details > summary {
    list-style: none;
    position:relative;
    padding-inline-start: 2rem;
}

details {
    --accordion-title-size:clamp(1rem, 2vmin, 1.5rem);
    --accordion-margin:1rem;
}

details:not(:last-of-type) {
    margin-block-end: var(--accordion-margin, 1rem);
}

details > summary {
    cursor: pointer;
    outline:none;
    user-select: none;
    color: var(--primary-color, rgb(var(--color-highlight)));
    font-size: var(--accordion-title-size);
}

details summary:focus-visible {
    outline: dashed var(--primary-color, rgba(var(--color-highlight), var(--outline-opacity))) 2px;
}

details .content {
    margin-block-start: .5rem;
    padding-inline-start: var(--inline-padding, 0);
}


:host details > summary::-webkit-details-marker {
    display:none;
}

:host details > summary ad-icon {
    position:absolute;
    left:0;
    transform:rotate(0);
    transition: transform .1s ease;
}

:host details[open] > summary ad-icon {
    transform: rotate(90deg);
}

:host([accordion]) details > summary ad-icon {
    transform: rotate(-90deg);
}

:host([accordion]) details[open] > summary ad-icon {
    transform: rotate(0deg);
}